<template>
<div class="loader" :class="!$store.state.clientConfig.logo.usePrimaryBg ? 'nonTransparent' : 'transparent'">
    <div class="loader-wrapper">
        <img
            :src="`${$store.state.clientConfig.directoryUrl}/img/logo.png`"
          />
        <div class="loading" />
        <h5>{{loadingText}}</h5>
    </div>
</div>
</template>

<script>
// import loadingOrb from '@/components/layout/loadingOrb.vue';

export default {
    name: 'page-loader',
    // components: { loadingOrb },
    props: {
        themeColour: {
            type: String,
            required: false,
            default: () => '#F1F1F1',
        },
        loadingText: {
            type: String,
            required: false,
            default: () => 'Loading your details...',
        },
    },
    data () {
        return {
        };
    },
};
</script>

<style lang="scss" scoped>
.loader{
    z-index: 10;
    position: fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    &.transparent {
        color: var(--navFont);
        background: var(--navColour);
    }
    &.nonTransparent {
        background: white;
        color: var(--primaryColour);
    }
   .loader-wrapper{
       position: absolute;
       width: 400px;
        left: 50%;
        top:40%;
        transform: translate(-50%, -50%);
        text-align: center;
        img{
            max-width: 80%;
            margin-bottom: 20px;
        }
        svg{
            margin-bottom: 20px;
        }
        h5{
            margin-top:40px;
        }
   }

    @keyframes rotate {
        0% { transform: rotate(0deg); border-color: var(--primaryColour); }
        50% { transform: rotate(360deg); border-color: var(--secondaryColour); }
        100% { transform: rotate(720deg); border-color: var(--primaryColour); }
    }

   .loading {
       height: 7rem;
       width: 7rem;
       border-left: 0px solid;
       border-top: 1px solid;
       border-right: 2px solid;
       border-bottom: 3px solid;
       border-color: var(--secondaryColour);
       border-radius: 100%;
       margin: 0 auto 1rem auto;
       animation: rotate 3s linear infinite;
    }
}

</style>
